import React from "react";
import HeadLines from "../../CommonComponents/HeadLines";
import Button from "../../CommonComponents/Button";
import style from "./style.module.css";
import { isMobile } from "../../helperFunc";
import TwoLineWidget from "../../CommonComponents/TwoLineWidget/TwoLineWidget";
import { downloadDocThroughDoms } from "../../../../../_services/Arya2.0/DomsApi";
import MultiLanguageTranslate from "../../../../../_components/Translate/MultiLangTranslate";
import {
  maxTwoDigitFractionHandler,
  titleCase,
} from "../../CommonFunctions/Function";

const InvoiceCardItem = ({ item, index, handleClick }) => {
  const downloadFile = async () => {
    if (!isNaN(item?.invoiceLink)) {
      const payload = {
        documentId: item?.invoiceLink,
      };
      var apiresponse = await downloadDocThroughDoms(payload);
      if (apiresponse?.data?.payload?.document) {
        window.open(apiresponse?.data?.payload?.document, "_blank");
      }
    } else {
      window.open(item?.invoiceLink, "_blank");
    }
  };

  const isDisbursement = item.cardType === "pendingDisbursement";

  return (
    <div
      key={index}
      className={`boxRadius8 ${style.cardborder} ${isMobile ? `w-100` : ""}`}
    >
      <div
        className={
          isMobile
            ? `padding-top20 padding-left20 padding-right20 padding-bottom16 w-100 ${style["minHeight147"]}`
            : `padding16 ${style["minHeight180"]}`
        }
      >
        <HeadLines
          text={item?.invoiceHeading}
          className={`${
            isMobile
              ? `font-size14 font-weight600 line-height16 ${style.blackColor}`
              : `font-size18 font-weight400 line-height21 ${style.darkColor}`
          }`}
        />
        <TwoLineWidget
          title={isDisbursement ? "Disbursement Amount" : "Invoice Amount"}
          subtitle={`₹${maxTwoDigitFractionHandler(item?.invoiceAmount)}`}
          subtitleClassName={`${
            isMobile ? style["mobilesubtitle-2-line"] : style["subtitle-2-line"]
          } ${style["fontWeight700"]}`}
          titleClassName={`${
            isMobile ? style["mobiletitle-2-line"] : style["title-2-line"]
          }`}
          className={
            isMobile
              ? `margin-top12 margin-bottom12`
              : `margin-top16 margin-bottom16`
          }
        />
        <div className="d-flex align-items-center justify-content-space-between">
          <TwoLineWidget
            title="Commodity"
            subtitle={titleCase(item?.commodity)}
            subtitleClassName={
              isMobile
                ? `${style["mobilesubtitle-2-line"]}`
                : `${style["subtitle-2-line"]}`
            }
            titleClassName={
              isMobile
                ? `${style["mobiletitle-2-line"]}`
                : `${style["title-2-line"]}`
            }
          />
          {item?.invoiceHeading !== "Monthly Interest Due" &&
            !isDisbursement && (
              <div className="d-flex flex-d-col gap4">
                <span
                  className={`${
                    isMobile
                      ? style["mobiletitle-2-line"]
                      : style["title-2-line"]
                  }`}
                >
                  <MultiLanguageTranslate title="View Invoice" />
                </span>
                <span
                  className={`${
                    isMobile
                      ? style["mobilesubtitle-2-line"]
                      : style["subtitle-2-line"]
                  } ${style.downloadInvoice} cursorPointer`}
                  onClick={downloadFile}
                >
                  <MultiLanguageTranslate title="Download Invoice" />
                </span>
              </div>
            )}
        </div>
      </div>
      <div>
        <Button
          className={`${style["mobileButton"]} backAccent3 textColorWhite padding-top12 padding-bottom12 font-size14 line-height16 font-weight400 w-100`}
          onClick={() => handleClick(index, item)}
        >
          <MultiLanguageTranslate title={`${item?.buttonLabel}`} />
        </Button>
      </div>
    </div>
  );
};

export default InvoiceCardItem;
